import styled, {css} from "styled-components"
import withBranding, {WithBranding} from "@irati/brand/withBranding"
import {BRAND_LOGO_DIMENSIONS} from "@irati/brand/constants/brand"
import Button from "@irati/ui/src/Button"

interface ColorProps extends WithBranding {
  small?: boolean,
  color?: string
}

export const ColorCss = css<ColorProps>`
  text-align: right;
  width: ${({small}) => small ? "180px" : "360px"};
  height: ${({small}) => small ? "90px" : "120px"};
  background-color: ${({branding, color}) => color || branding.primaryColour};
  margin-bottom: ${({theme}) => theme.spacing.two};
  cursor: pointer;
`

export const Color = withBranding(styled.div<ColorProps>`
  ${ColorCss}
`)

export const WithMargin = styled.div`
  margin-right: ${({theme}) => theme.spacing.one};
`

interface ColorPreviewProps {
  selectedId: string,
  itemId: string
}

export const ColorPreview = styled.div<ColorPreviewProps>`
  ${ColorCss}
  ${({selectedId, itemId}) => (selectedId && selectedId !== itemId && `
    opacity: 0.5;
  `)}
`

export const BrandSettingsChoiceImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed ${({theme}) => theme.colors.greys.mediumDark};
  min-width: 360px;
  height: 120px;
  margin-bottom: ${({theme}) => theme.spacing.two};
`

export const AlignButton = styled(Button)`
  align-self: flex-start;
`

export const BrandSettingsChoiceImage = styled.img`
  width: ${BRAND_LOGO_DIMENSIONS.width}px;
  height: ${BRAND_LOGO_DIMENSIONS.height}px;
`

export const HexCode = styled.div`
  display: inline-block;
  position: relative;
  top: 8px;
  right: 8px;
  font-family: ${({theme}) => theme.font.default};
  text-transform: uppercase;
  color: ${({theme}) => theme.colors.utility.ink};
  padding: 4px 8px;
  background-color: ${({theme}) => theme.colors.utility.highlight};
  border-radius: 3px;
`
